export enum InboxItemType {
  INTRODUCTION = 'INTRODUCTION',
  DATA_REQUEST = 'DATA_REQUEST',
  COMMUNITY_REQUEST = 'COMMUNITY_REQUEST',
  CONNECTION_INVITE = 'CONNECTION_INVITE',
  ADMIN_INVITE = 'ADMIN_INVITE',
  EVENT_INVITE = 'EVENT_INVITE',
  COMMUNITY_INVITE = 'COMMUNITY_INVITE',
}

export type PropertyType = 'BIRTHDATE' | 'PHONENUMBER' | 'EMAIL' | 'ADDRESS' | 'MOMENT' | 'BUSINESSNAME' | 'SOCIAL';

export enum InviteType {
  PERSONAL = 'PERSONAL',
  NATIVE_PHONENUMBER = 'NATIVE_PHONENUMBER',
  DISCOVER_GROUP = 'DISCOVER_GROUP',
  BUSINESS = 'BUSINESS',
  EVENT = 'EVENT',
}

export type InboxItem = {
  type: InboxItemType;
  createdAt: Date;
  entityId: number;
  fromAlias?: string;
  fromPicture?: string;
  fromId?: number;
};

export type InboxItemWithDataRequest = InboxItem & {
  requestedProps: PropertyType[];
};

export type InboxItemWithIntroduction = InboxItem & {
  toAlias?: string;
  toPicture?: string;
  toId?: number;
};

export type InboxItemWithCommunityInfo = InboxItem & {
  communityName: string;
  communityPicture?: string;
  communityId?: number;
};

export type InboxItemCommunityInfoWithInvite = InboxItemWithCommunityInfo & {
  businessInviteLinkId?: string;
};

export type InboxItemWithConnectionInvite = InboxItem & {
  inviteType: InviteType;
  nativeContactId?: string;
};

export type InboxItemWithEventInvite = InboxItem & {
  eventTitle: string;
  businessId?: number;
};

export type InboxBody = {
  /**
   * The list of introductions
   */
  introductions: InboxItemWithIntroduction[];

  /**
   * The list of data requests
   */
  dataRequests: InboxItemWithDataRequest[];

  /**
   * The invites to a community/business
   */
  communityInvites: InboxItemCommunityInfoWithInvite[];

  /**
   * The connection requests from communities
   */
  communityRequests: InboxItemWithCommunityInfo[];

  /**
   * The connection invites from personalLinks
   */
  connectionInvites: InboxItemWithConnectionInvite[];

  /**
   * The event invites
   */
  eventInvites: InboxItemWithEventInvite[];
};
